import { request } from '@/utils/request'
export default {
    pageData: (params, loading) => {
        return request('/api/user/queryPage', params, loading)
    },
    webAdd: (params, loading) => {
        return request('/api/websitetemplateinfo/save', params, loading)
    },
    webInfo: (params, loading) => {
        return request('/api/websitetemplateinfo/info', params, loading)
    },
}


// WEBPACK FOOTER //
// ./src/api/webTemplate.js